document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-cart-discount-form]');
  if (!form) return;

  event.preventDefault();
  const input = form.querySelector('[name="discount"]');
  const code = input?.value.trim();
  if (!code) {
    input?.focus();
    return;
  }

  const discountBase = form.dataset.discountBase;
  const cartUrl = form.dataset.cartUrl;
  window.location.assign(`${discountBase}${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartUrl)}`);
});
